<markant-table-pagination
  class="pagination-footer"
  [selectLabel]="selectLabelKey() | transloco"
  [goToLabel]="goToPageKey() | transloco"
  [totalCount]="totalCount()"
  [pageSize]="pageSize()"
  [index]="pageIndex()"
  (indexChange)="indexChanged.emit($event)"
  (pageSizeChange)="onPageSizeChange($event)"
>
  @for (size of pageSizes(); track $index) {
    <markant-table-pagination-select-option
      slot="selectOptions"
      [value]="size"
      [selected]="size === pageSize()"
    >
      {{ size }}
    </markant-table-pagination-select-option>
  }
</markant-table-pagination>
